export default {"src":"/_next/static/media/chIcon.1f10558f.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};